export default "__VITE_ASSET__BJUtRDNx__"